import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Router from './pages/Router';
import Login from './pages/Login';
import Reg from './pages/Login/reg';
import View from './pages/View';
import History from './pages/History';
import Summary from './pages/History/summary';
import Detail from './pages/History/detail';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          <Route index element={<View/>}/>
          <Route path="router" element={<Router/>}/>
          <Route path="login" element={<Login/>}/>
          <Route path="reg" element={<Reg/>}/>
          <Route path="history" element={<History/>}/>
          <Route path="history/summary" element={<Summary/>}/>
          <Route path="history/detail" element={<Detail/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
